import { gql } from '@apollo/client';

export const GET_USER_LEVEL = gql`
  query GetUserLevel {
    getUserLevel {
      userId
      currentLevel
      currentLevelName
      currentLevelDescription
      totalTradeValue
      currentLevelThreshold
      nextLevelThreshold
      progressToNextLevel
      amountToNextLevel
      badge
      isMaxLevel
    }
  }
`;

export const GET_ALL_LEVELS = gql`
  query GetAllLevels {
    getAllLevels {
      level
      name
      description
      threshold
      nextThreshold
      badge
    }
  }
`;

 